import { useCallback, useContext } from "react"
import { useFindMissionSensorList } from "../api/MissionEditApi"
import { RootContext } from "../store/Context"
import { MissionActiveFlow, MissionType } from "../store/types/MissionsTypes"
import { Types } from "../store/types/Types"
import { useNexusProjectNumber } from "./useNexusParams"

export const useMissions = () => {
    const projectNumber = useNexusProjectNumber()
    const { state, dispatch } = useContext(RootContext)
    const { activeFlow } = state.missions

    const isNoFlight = activeFlow != null && activeFlow === MissionActiveFlow.NO_FLIGHT
    const isNoAcquisition = activeFlow != null && activeFlow === MissionActiveFlow.NO_ACQUISITION
    const isNoFile = activeFlow != null && activeFlow === MissionActiveFlow.NO_FILE
    const isFullFlight = activeFlow != null && activeFlow === MissionActiveFlow.FULL_FLIGHT

    // We plan to remove the useMissions hook soon but for now since we need the sensor list for the mission name
    //  we are adding the connecting API call here
    const sensorListResponse = useFindMissionSensorList(projectNumber)
    const sensorListResult = sensorListResponse.data
    const sensors = sensorListResult?.sensors ?? []

    /**
     * Toggle between NV5 team and non-NV5 team (vendor).
     */
    const handleVendor = useCallback(
        (value: boolean) => {
            dispatch({
                type: Types.Missions_UpdateIsVendorFlow,
                payload: value,
            })
        },
        [dispatch],
    )

    /**
     * Change one or more values in selectedMission.
     */
    const handleMissionDataChange = useCallback(
        (data: Partial<MissionType>) => {
            dispatch({
                type: Types.Missions_UpdateMissionData,
                payload: { missionPart: data, sensors },
            })
        },
        [dispatch],
    )

    return {
        missions: state.missions,
        isNoFlight,
        isNoAcquisition,
        isNoFile,
        isFullFlight,
        handleMissionDataChange,
        handleVendor,
        dispatch,
    }
}
